var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDismantlerVehicles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.143,
    height: 24.435,
    viewBox: "0 0 32.143 24.435",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11.492 -14.511)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.492 14.511)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.148,25.723a10.072,10.072,0,0,1-4.4-.892l-.242-.128.021-.273a6.064,6.064,0,0,0-.227-1.884c-.155-.662-.29-1.233.037-1.646a1.265,1.265,0,0,1,1.058-.389H21.9a1.265,1.265,0,0,1,1.058.389c.327.413.193.984.038,1.647a6.075,6.075,0,0,0-.227,1.883l.021.273-.242.128A10.072,10.072,0,0,1,18.148,25.723ZM14.372,24.2a10.019,10.019,0,0,0,3.776.69,10.019,10.019,0,0,0,3.776-.69,7.5,7.5,0,0,1,.259-1.841c.074-.314.2-.841.121-.937,0,0-.067-.073-.4-.073H14.395c-.336,0-.4.072-.4.073-.076.1.047.622.121.936A7.484,7.484,0,0,1,14.372,24.2Z",
    transform: "translate(-2.164 -3.379)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.421,10.373a.418.418,0,0,1-.382-.247l-2.449-5.5A6.4,6.4,0,0,0,20.752.835H12.844A6.891,6.891,0,0,0,6.555,4.92L4.237,10.126a.418.418,0,1,1-.763-.341L5.792,4.58A7.729,7.729,0,0,1,12.844,0h7.908a7.233,7.233,0,0,1,6.6,4.287l2.449,5.5a.418.418,0,0,1-.382.588",
    transform: "translate(-0.567)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.655,11.828H6.488a.416.416,0,0,1-.35-.19.421.421,0,0,1-.032-.4L8.425,6.035a5.317,5.317,0,0,1,4.853-3.152h7.908a4.826,4.826,0,0,1,4.4,2.858l2.448,5.5a.419.419,0,0,1-.382.588M7.131,10.993H27.013L24.825,6.081a3.988,3.988,0,0,0-3.64-2.363H13.278a4.482,4.482,0,0,0-4.09,2.656Z",
    transform: "translate(-1 -0.475)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.81,23.608A.418.418,0,0,1,.4,23.244C.36,22.956-.5,16.17.428,14.022A10.515,10.515,0,0,1,3.043,11.5a.418.418,0,0,1,.493.674,10.2,10.2,0,0,0-2.341,2.177C.5,15.962.982,21.24,1.225,23.138a.417.417,0,0,1-.362.467.383.383,0,0,1-.053,0",
    transform: "translate(0 -1.881)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.942,23.608a.383.383,0,0,1-.053,0,.417.417,0,0,1-.362-.467c.243-1.9.723-7.177.031-8.787a10.2,10.2,0,0,0-2.341-2.177.418.418,0,0,1,.493-.674,10.514,10.514,0,0,1,2.615,2.522c.924,2.148.068,8.934.031,9.222a.418.418,0,0,1-.413.364",
    transform: "translate(-5.608 -1.881)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.832,12.761a1.772,1.772,0,0,1,0-3.544.418.418,0,1,1,0,.835.937.937,0,0,0,0,1.874.418.418,0,1,1,0,.835",
    transform: "translate(-0.01 -1.518)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.7,10.053H2.1a.418.418,0,1,1,0-.835H3.7a.418.418,0,1,1,0,.835",
    transform: "translate(-0.277 -1.518)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.091,12.761a.418.418,0,0,1,0-.835.937.937,0,0,0,0-1.874.418.418,0,0,1,0-.835,1.772,1.772,0,0,1,0,3.544",
    transform: "translate(-5.876 -1.518)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.774,10.053H34.169a.418.418,0,1,1,0-.835h1.605a.418.418,0,0,1,0,.835",
    transform: "translate(-5.56 -1.518)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.18,18.9a1.692,1.692,0,0,1,.211.013l5.819.738a1.187,1.187,0,0,1,1.115.994l.063.752a.952.952,0,0,1-.261.727,1.453,1.453,0,0,1-1.061.429c-.038,0-.076,0-.114,0L3.368,22.17a1.257,1.257,0,0,1-1.184-.843l-.3-1.111a.92.92,0,0,1,.17-.813A1.407,1.407,0,0,1,3.18,18.9Zm5.886,2.819a.622.622,0,0,0,.446-.16.128.128,0,0,0,.043-.092l-.063-.752c-.006-.077-.148-.2-.388-.234l-5.819-.738a.851.851,0,0,0-.106-.007.6.6,0,0,0-.461.177c-.036.047-.029.074-.025.088l.3,1.112c.022.081.174.208.433.225l5.584.379Z",
    transform: "translate(-0.306 -3.113)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.724,18.9h0a1.407,1.407,0,0,1,1.123.5.92.92,0,0,1,.17.812l-.3,1.112a1.257,1.257,0,0,1-1.184.843l-5.583.379a1.481,1.481,0,0,1-1.176-.426.95.95,0,0,1-.26-.727l.063-.752a1.187,1.187,0,0,1,1.115-.994l5.818-.738A1.689,1.689,0,0,1,33.724,18.9Zm-5.886,2.819.057,0,5.584-.379c.26-.017.412-.144.433-.224L34.21,20c0-.014.011-.041-.025-.088a.6.6,0,0,0-.461-.177.851.851,0,0,0-.106.007l-5.818.738c-.24.03-.382.157-.388.234l-.063.753a.127.127,0,0,0,.043.092A.622.622,0,0,0,27.838,21.718Z",
    transform: "translate(-4.368 -3.113)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.144,28.626A51.293,51.293,0,0,1,5.137,27.469,28.964,28.964,0,0,1,.873,26.238l.315-.774h0a28.881,28.881,0,0,0,4.155,1.195,50.661,50.661,0,0,0,11.287,1.13c4.133-.037,9.347-1.13,14.773-2.345l.183.815c-5.472,1.225-10.733,2.328-14.948,2.366Z",
    transform: "translate(-0.144 -4.191)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDismantlerVehicles);
export default __webpack_public_path__ + "static/media/dismantler_vehicles.3ccac465ff8a0ed2b22dcf52cec39146.svg";
export { ForwardRef as ReactComponent };